import { lazyNamed } from 'src/utils/lazyNamed.ts';

export const Creatives = {
  CreativesList: lazyNamed(() => import('./containers/CreativesList/index.tsx'), 'CreativesList'),
  CreativeForm: lazyNamed(() => import('./containers/CreativeForm/index.tsx'), 'CreativeForm'),
};
